/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from 'moment-timezone';
import { Link } from '@fluentui/react';

import { getDisplayedDuration } from './get-available-timeslots';

export const messageMaxCount = 200;

export const getDurationOptions = i18n => ([
  { key: '30 minutes', text: i18n.getString(_TL_('30 minutes')) },
  { key: '1 hour', text: i18n.getString(_TL_('1 hour')) },
]);

export const getColumns = ({
  i18n,
  classes,
  currentTime,
  timeZoneOffset,
  onEditAppointment = () => {},
  onCancelAppointment = () => {},
}) => ([
  {
    key: 'time',
    name: i18n.getString(_TL_('Appointment time')),
    minWidth: 150,
    maxWidth: 150,
    fieldName: 'time',
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
    onRender: (item) => {
      // Time should be shown in owner pre-defined time zone
      const bookingTime = moment(item.time).utcOffset(timeZoneOffset);
      const formattedTime = bookingTime.format('MM/DD/YYYY h:mm A');
      // Existing bookings that past current time won't be able to edit.
      const isDisabled = bookingTime.isBefore(currentTime);
      return (
        <div className="appointment-time">
          <div>{formattedTime}</div>
          <Link href="#" onClick={() => onEditAppointment(item)} underline disabled={isDisabled}>
            {i18n.getString(_TL_('Edit appointment'))}
          </Link>
        </div>
      );
    },
  },
  {
    key: 'duration',
    name: i18n.getString(_TL_('Duration')),
    fieldName: 'timeInMinutes',
    minWidth: 80,
    maxWidth: 80,
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
    onRender: item => (
      <span>{getDisplayedDuration(item.timeInMinutes).text}</span>
    ),
  },
  {
    key: 'customerName',
    name: i18n.getString(_TL_('Customer name')),
    fieldName: 'name',
    minWidth: 120,
    maxWidth: 120,
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
  },
  {
    key: 'phoneNumber',
    name: i18n.getString(_TL_('Phone number')),
    fieldName: 'phoneNumber',
    minWidth: 100,
    maxWidth: 100,
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
  },
  {
    key: 'email',
    name: i18n.getString(_TL_('Email')),
    fieldName: 'emailAddress',
    minWidth: 120,
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
    onRender: item => (
      <Link href={`mailto:${item.emailAddress}`} target="_blank">
        {item.emailAddress}
      </Link>
    ),
  },
  {
    key: 'notes',
    name: i18n.getString(_TL_('Notes')),
    fieldName: 'message',
    minWidth: 160,
    maxWidth: 160,
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
  },
  {
    key: 'cancel',
    name: '',
    className: classes.columnCell,
    headerClassName: classes.topBottomBorder,
    onRender: (item) => {
      const bookingTime = moment(item.time);
      // Existing bookings that past current time won't be able to cancel.
      const isDisabled = bookingTime.isBefore(currentTime);
      return (
        <div className="cancel-appointment">
          <Link href="#" onClick={() => onCancelAppointment(item)} disabled={isDisabled}>
            {i18n.getString(_TL_('Cancel appointment'))}
          </Link>
        </div>
      );
    },
  },
]);
